import { API } from '@/utils/api.utils';
import api from '@/utils/api.utils';

export interface Draft {
  draft_id: string;
  prompt: string;
  user_id: string;
  essay: string;
  draft_type: string;
  wordCount: number;
  university: string;
  status: string;
  created_at?: string;
}

export interface AnalysisPayload {
  prompt_id: number;
  essay: string;
  university_id: number;
  draft_id?: number;
}

export interface Improvement {
  id: number;
  type: string;
  user_vote: string;
  content: string;
}

export interface AnalysisResult {
  university_id: number;
  prompt_id: number;
  draft_id: number;
  draft_version_id: number;
  improvements: Improvement[];
}

export interface TokenResponse {
  payment_details: {
    token_count: number;
    is_subscribed: boolean;
  };
}

export const textAnalyzerService = {

  // Analyze essay
  async analyzeEssay(payload: AnalysisPayload): Promise<AnalysisResult> {
    const response = await api.post(API.ANALYZE, payload);
    return response.data;
  },

  // Save draft
  async saveDraft(draft: Omit<Draft, 'draft_id'>): Promise<void> {
    await api.post(API.SAVE_DRAFT, draft);
  },

  // Get user tokens
  async getTokens(userId: string): Promise<TokenResponse> {
    const response = await api.get(`${API.GET_TOKENS}?user_id=${userId}`);
    return response.data;
  },

  // Update tokens (reduce by 1)
  async updateTokens(userId: string): Promise<{ success: boolean; new_token_count: number }> {
    const response = await api.post(API.UPDATE_TOKENS, { user_id: userId });
    return response.data;
  },

  // Validate subscription
  async validateSubscription(userId: string): Promise<{ status: string }> {
    const response = await api.post(API.VALIDATE_SUBSCRIPTION(userId), {});
    return response.data;
  }
}; 